// extracted by mini-css-extract-plugin
export default {"search":"styles_search__2H87R","search_inp":"styles_search_inp__YL9Jh","search_icon":"styles_search_icon__WKDSk"};